import { render } from "./accordion-block.vue?vue&type=template&id=458eab7d"
import script from "./accordion-block.vue?vue&type=script&lang=js"
export * from "./accordion-block.vue?vue&type=script&lang=js"

import "./accordion-block.vue?vue&type=style&index=0&id=458eab7d&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__